<template>
  <div>
    <b-card no-body>
      <b-row class="mb-3">
        <b-col class="mb-2" md="12" lg="12" xl="12">
          <label class="mb-1 text-white" for="">Comment</label>
          <textarea class="form-control" rows="3" placeholder="" v-model="oModel.comments"></textarea>
        </b-col>
      </b-row>
      
      <!-- Fire Extinguisher -->
      <hr class="hr" />
      <b-row class="mb-3">
        <b-col class="mb-2" md="12" lg="12" xl="12"> <span class="text-white h3">Fire Extinguisher Information</span>
          <b-list-group-item class="bg-cyan text-green text-center"
            style="width: 10px; display: inline; margin: 5px; padding: 5px; border-radius: 0.5rem;"
            @click="fire_extinguisher_add">
            <i class="icon-plus-green-cs"></i>
          </b-list-group-item>
        </b-col>
      </b-row>
      <div v-for="(item, index) in oModel.fire_extinguisher" :key="index">
        <b-row class="mb-4" v-if="item.id != null">
          <b-col class="mb-1" cols="12" md="12" lg="6" xl="5">
            <b-form-input placeholder="Location" v-model="item.location" required></b-form-input>
          </b-col>
          <b-col class="mb-1" cols="5" md="5" lg="2" xl="3">
            <b-form-input type="number" placeholder="no #" v-model="item.number_of_extinguisher" required></b-form-input>
          </b-col>
          <b-col class="mb-1" cols="7" md="7" lg="4" xl="4">
            <b-form-input type="date" placeholder="Expiration Date" v-model="item.fire_extinguisher_expired_date" required></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mb-4" v-if="!item.id">
          <b-col class="mb-1" cols="12" md="12" lg="6" xl="5">
            <b-form-input placeholder="Location" v-model="item.location" required></b-form-input>
          </b-col>
          <!-- <b-col class="mb-1" cols="3" md="3" lg="2" xl="3"> -->
          <b-col class="mb-1" cols="5" md="5" lg="2" xl="3">
            <b-form-input type="number" placeholder="no #" v-model="item.number_of_extinguisher" required></b-form-input>
          </b-col>
          <!-- <b-col class="mb-1" cols="7" md="7" lg="3" xl="4"> -->
          <b-col class="mb-1" cols="7" md="7" lg="4" xl="4">  
            <b-form-input type="date" placeholder="Expiration Date" v-model="item.fire_extinguisher_expired_date" required style="display: inline; width: 85%"></b-form-input>
            <base-button type="danger" class="btn-sm" @click="fire_extinguisher_remove(index)" style="margin-left: 10px;">X</base-button>
          </b-col>
          <!-- <b-col class="mb-1" cols="2" md="2" lg="1" xl="1">
            <base-button type="danger" class="btn-sm"
              @click="fire_extinguisher_remove(index)">remove</base-button>
          </b-col> -->
        </b-row>        
      </div>

      <!-- update button -->
      <hr class="hr" />
      <b-row class="mb-3" v-if="shareData.status_tnc != 'APPROVED'">
        <b-col class="mb-2">
          <div style="float: right;">
            <base-button type="tn btn-sm base-button btn-primary" @click="save_comment()">Save Comment</base-button>
          </div>
        </b-col>
      </b-row>
    </b-card>



    <!-- Modal loading / in progress -->
    <!-- <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="" :no-close-on-backdrop="true"> -->
    <b-modal ref="modal-loading-in-progress" size="lg" centered hide-footer hide-header title="">
      <div class="d-block">
        <!-- date | time | project name | site name -->
        <b-row class="mb-3">
          <b-col>
            <div class="text-center text-muted mb-4">
              <h1 class="text-white"><b>Loading in progress</b></h1>
            </div>
            <div class="text-center">
              <div style="color: #ffffff;">
                <!-- <span class="fa fa-spinner fa-spin fa-3x"></span> -->
                <span class="icon-spinner-cs"></span>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-modal>

  </div>
</template>


<script>
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from "@/assets/js/config.js";
import ErrorFunctionMixin from "@/assets/js/errorFunctionMix.js";
import CustomLibHelper from "@/assets/js/customLibHelper.js";
import axios from "axios";

// import { ToggleButton } from 'vue-js-toggle-button'

export default {
  props: ['shareData', 'commentData'],
  mixins: [ErrorFunctionMixin, CustomLibHelper],
  components: {
    // ToggleButton,
  },
  data() {
    return {
      oDev: {
        debug: false,
      },
      // oField: {
      //   toggle_yesno_color: { checked: '#75C791', unchecked: '#787785', disabled: '#CCCCCC' },
      //   toggle_yesno_value: { checked: 'Yes', unchecked: 'No' },
      // },
      oModel: {
        comments: null,
        fire_extinguisher: [],
      },
    }
  },
  methods: {
    populate_comment() {
      this.devMsg(this.oDev.debug, 'populate_comment', 'gs')
      this.devMsg(this.oDev.debug, this.commentData)

      this.oModel = this.commentData;

      this.devMsg(this.oDev.debug, '', 'ge')
    },
    save_comment() {
      if (this.validate_comment()) {
        this.$refs['modal-loading-in-progress'].show();

        this.devMsg(this.oDev.debug, 'save_comment', 'gs');

        // let api_url = apiDomain + 'qaqc/create_qaqc_comments/' + this.$route.params.id;
        let api_url = apiDomain + 'qaqc/update_qaqc_comments/' + this.$route.params.id;

        this.devMsg(this.oDev.debug, 'api_url')
        this.devMsg(this.oDev.debug, api_url)

        this.devMsg(this.oDev.debug, 'PAYLOAD this.oModel')
        this.devMsg(this.oDev.debug, this.oModel)

        axios
          .post(api_url, this.oModel, { headers: getHeader() })
          .then((response) => {
            if (response.status === 200) {
              this.msg_notify_ok('<b>Update Comment Successfully Created and Submitted.</b>');
            }
          })
          .catch((error) => {
            if (error.response) {
              // Handle error with response
              this.errorFunction(error, "Update Comment Entry Submit");
            } else {
              // Handle error without response
              this.msg_notify_sembcorp();
            }
          })
          .finally(() => {
            this.$refs['modal-loading-in-progress'].hide();
          });

        this.devMsg(this.oDev.debug, '', 'ge');
      }
    },
    validate_comment() {
      let checker = false;
      if (
        !this.oModel.comments
      ) {
        if (!this.oModel.comments) {
          this.redErrorNotify("<b>Invalid Input : Comment is a Mandatory Field.</b>");
        } else {
          this.redErrorNotify("<b>Invalid Input : Please fill in all the Mandatory Fields.</b>");
        }
      } else {
        checker = true;
      }

      let arrFE = this.oModel.fire_extinguisher;
      if( arrFE.length > 0 ) {
        arrFE.forEach( (entry => {
          if (
            !entry.location ||
            !entry.number_of_extinguisher ||
            !entry.fire_extinguisher_expired_date
          ) {
            checker = false
          }
        }))

        if ( !checker ) {
          this.redErrorNotify("<b>Invalid Input : All field in Fire Extinguisher is a Mandatory Field.</b>");
        }

      }

      return checker;
    },
    fire_extinguisher_add() {
      this.devMsg(this.oDev.debug, 'fire_extinguisher_add', 'gs')

      this.oModel.fire_extinguisher.push({
        location: '',
        number_of_extinguisher: '',
        fire_extinguisher_expired_date: '',
      });

      this.devMsg(this.oDev.debug, 'this.oModel')
      this.devMsg(this.oDev.debug, this.oModel)

      this.devMsg(this.oDev.debug, '', 'ge')
    },
    fire_extinguisher_remove(index) {
      this.oModel.fire_extinguisher.splice(index, 1);
    },

  },
  created() {
    this.devMsg(this.oDev.debug, 'created', 'gs')
    this.devMsg(this.oDev.debug, this.commentData, 'ge');

    this.populate_comment();
  },
  mounted() {
  },
  beforeMount() {
  }
}
</script>

<!-- form element -->
<style scoped>
/deep/ hr {
  background-color: white;
}

/deep/ .form-control {
  background-color: #fff;
  border-color: #fff;
  color: #000;

  &:focus {
    background-color: #fff;
    border-color: #fff;
    /* color: white; */
  }

  &::placeholder {
    color: rgb(163, 163, 163);
  }
}

/deep/ .form-control {
  &:focus {
    &::placeholder {
      color: rgb(163, 163, 163);
    }
  }
}

/deep/ .input-group-text {
  background-color: #2C545A;
  ;
  color: white;

  &:focus {
    background-color: #2C545A;
    ;
    border-color: #1D4147;
    color: white;
  }
}

/deep/ input::-webkit-input-placeholder {
  color: #fff;
}

/deep/ input::-moz-input-placeholder {
  color: #fff;
}

/deep/ input::-ms-input-placeholder {
  color: #fff;
}

/deep/ .el-input .el-input__inner {
  background-color: #2C545A;
  color: #fff;
  border: 0px;
  border-radius: 10px;
  padding-top: 3px;
  padding-bottom: 2px;

  /* &::placeholder {
    color: white;
  } */
}

/deep/ .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #23504e;
}

/deep/ .el-select-dropdown {
  background-color: #306b74;
  margin: 0px;
}

/deep/ .el-select-dropdown__item {
  color: white;
  background-color: #183034;

  ::hover {
    background-color: #2C545A
  }

}

/deep/ .el-select {
  .el-input .el-input__inner {
    &::placeholder {
      color: white;
    }
  }

}

/deep/ .el-select__input {
  color: white;
  background-color: #2C545A;
}

/deep/ .el-select__input.hover,
.el-select__input:hover {
  background-color: #23504e;
}
</style>

<!-- tabs -->
<style scoped>
/deep/ .tabs {
  background-color: #24454a;
}

/*  .nav-tabs .nav-item.show .nav-link, .nav-tabs  */

/deep/ .nav-link.active {
  color: #ffffff !important;
  background-color: #2c585f !important;
  border-color: #ffffff #ffffff #24454a !important;
}

/deep/ .tab-content {
  padding: 10px;
}

/deep/ .card {
  background-color: #2c585f;
}

/deep/ .card-footer {
  /* padding: 0.5rem 0.5rem; */
  padding-bottom: 15px;
  background-color: #24454a;
  border-top: 1px solid rgba(0, 0, 0, .05);
}
</style>

<!-- modal -->
<style scoped>
/deep/ .modal-content {
  background-color: #306b74 !important;
}

/deep/ .modal-body {
  background-color: #306b74 !important;
}

/deep/ .modal-row-header {
  padding-bottom: 20px;
}

/deep/ .modal-row-category {
  padding-top: 25px;
  padding-bottom: 0px;
}
</style>

<!-- dropdown action menu -->
<style scoped>
/deep/ .btn-dark,
.btn-dark:hover {
  color: #fff;
  background-color: #2c545a;
  border-color: #2c545a;
}

/deep/ .dropdown-menu {
  background-color: #23444a !important;
  border: 1px solid #ffffff;
}

/deep/ .dropdown-item {
  &:hover {
    background-color: #3a656b !important;
    color: #ffffff;
  }

  span {
    padding-left: 8px;
    vertical-align: super;
  }
}
</style>